<div class="min-h-screen bg-base-100 p-4">
  <div class="max-w-2xl w-full bg-white rounded-lg shadow-xl p-8 mx-auto mt-8">
    <div class="text-center mb-8">
      <!-- Success Icon -->
      <div class="daisy-mask daisy-mask-circle bg-success w-20 h-20 mx-auto mb-6 flex items-center justify-center">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
        </svg>
      </div>
      
      <h2 class="text-3xl font-bold text-success mb-4">Payment Successful!</h2>
      <p class="text-gray-600 mb-8">
        Thank you for your payment. You will be automatically enrolled in the courses once the payment is confirmed from our end. This process may take 2-5 working days.
      </p>
    </div>

    <div class="flex flex-col sm:flex-row gap-4 justify-center">
      <a routerLink="/order" class="daisy-btn daisy-btn-outline">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
        View Order Details
      </a>
      <a routerLink="/courses" class="daisy-btn daisy-btn-primary">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
        Continue Learning
      </a>
    </div>
  </div>
</div>
